import Certificat from "./Certificat";

/**
 * Page dédiée aux certifications, accessible depuis sa propre entrée de menu.
 * `Certificat` porte la liste et ses filtres ; cette page ne fournit que
 * l'enveloppe de mise en page, comme les autres écrans.
 */
const CertificatPage = () => (
  <div className="bostami-page-content-wrap">
    <div className="section-wrapper pl-60 pr-60 pt-60 pb-60">
      <Certificat />
    </div>
  </div>
);

export default CertificatPage;
